import { TableCellText } from '@pocketlaw/tetris';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { DesktopTableBodyCell } from '../styled';
export function DateCell(props) {
    const { createdAt } = props;
    const date = localizedFormatDate(createdAt);
    return (<DesktopTableBodyCell headers="createdAt">
      <TableCellText primary={date}/>
    </DesktopTableBodyCell>);
}
